import { validateToken, redirectToLogin } from '../../../utils/auth/tokenValidation';
import { SCREENMAKER_DATA, SCREENMAKER_START, SCREENMAKER_END } from "../type";

interface Action {
  type: string;
  payload?: any; 
  loading?: boolean;
}

interface ScreenMakerParams {
  page?: number;
  size?: number;
}

type Dispatch = (action: Action) => void;

const API_URL = process.env.REACT_APP_API_URL

export const getScreenMaker = (params: ScreenMakerParams = {}) => async (dispatch: Dispatch): Promise<void> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return;
  }
  
  try {
    dispatch({
      type: SCREENMAKER_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const page = params.page ?? 0;
    const size = params.size ?? 9;

    const response = await fetch(`${API_URL}/campaign/get-unapproved-files/${page}/${size}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: SCREENMAKER_DATA,
        payload: [{ res }], 
        loading: false,
      });
    } else {
      const res = await response.json();
      dispatch({
        type: SCREENMAKER_END,
        payload: [{ res }], 
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: SCREENMAKER_END,
      payload: false,
      loading: false,
    });
    console.error(error);
  }
};

export const getTransactionsByFile = (fileId: number, page: number, size: number) => async (dispatch: Dispatch): Promise<void> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return;
  }
  
  try {
    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/campaign/get-trx-by-file/${fileId}/${page}/${size}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    
    if (response.status === 200) {
      const res = await response.json();
      return res;
    }
  } catch (error) {
    console.error(error);
  }
};
